// extracted by mini-css-extract-plugin
export default {"lightColor":"#fff","blackColor":"#252930","darkGrayColor":"#686868","dark2GrayColor":"#979292","lightGrayColor":"#e8e8e8","light2GrayColor":"#f1f1f1"};